module.exports = __webpack_public_path__ + "static/media/logo-min.7481280b.svg";